import { jsx as _jsx } from "react/jsx-runtime";
import { LegendContainer } from './styles';
export const Legend = ({ colorContext = 'on-light', children }) => {
    return _jsx(LegendContainer, { "$colorContext": colorContext, children: children });
};
